export default __webpack_public_path__ + "static/media/b3-logo-azul.a6889965.png";